// Mobile detection
export const isMobileDevice =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobi/i.test(
    navigator.userAgent,
  ) ||
  (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
